import React, { Component } from 'react';
//import { Link } from 'react-router-dom';

import './Css/MainFooter.css';

class MainFooter extends Component {
    render() {
        return (
            <footer className="MainFooter footer">
                <div className="container">
                    <div className="content has-text-centered-tablet">
                        <div className="MainFooterLinkCover">
                            <a className="MainFooterLink has-text-white" href="https://www.facebook.com/TodayMap/">
                                <span className="icon is-medium"><i className="fab fa-facebook fa-2x"></i></span>
                                <span className="text">แผนที่วันนี้</span>
                            </a>
                        </div>
                        <div className="MainFooterLinkCover">
                            <a className="MainFooterLink has-text-white" href="https://line.me/R/ti/p/@ling-map">
                                <span className="icon is-medium"><i className="fab fa-line fa-2x"></i></span>
                                <span className="text">@ling-map</span>
                            </a>
                        </div>
                        <div className="MainFooterLinkCover">
                            <a className="MainFooterLink has-text-white" href="mailto:ling-active@tig-gis.com">
                                <span className="icon is-medium"><i className="fas fa-envelope-square fa-2x"></i></span>
                                <span className="text">lingmaps@tig-gis.com</span>
                            </a>
                        </div>
                        <div className="MainFooterLinkCover">
                            <div className="MainFooterLink has-text-white">
                                <span className="icon is-medium"><i className="fas fa-phone-square fa-2x"></i></span>
                                <span className="text">080-211-1143</span>
                            </div>
                        </div>
                        <div className="MainFooterLinkCover">
                            <a className="MainFooterLink has-text-white" href="https://www.youtube.com/channel/UCifLaiJ__Bd9h9CWFQCO0zg">
                                <span className="icon is-medium"><i className="fab fa-youtube fa-2x"></i></span>
                                <span className="text">Ling App Channel</span>
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default MainFooter;


// WEBPACK FOOTER //
// ./src/Components/MainFooter.js